// frontend/src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartWishlistProvider } from "./Context/CartWishlistContext";

/* ================= PAGES ================= */
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/CourseDetails";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import OTP from "./pages/OTP";
import Profile from "./pages/Profile";
import MyCourse from "./pages/MyCourse";
import Teacher from "./pages/Teacher";
import TeacherCourse from "./pages/TeacherCourse";
import AddCourse from "./pages/AddCourse";
import UploadVideo from "./pages/UploadVideo";
import EditCourse from "./pages/EditCourse";
import TeacherCourseDetails from "./pages/TeacherCourseDetails";
import EditVideo from "./pages/EditVideo";
import UploadCertificate from "./pages/UploadCertificate";
import MyCourseDetails from "./pages/MyCourseDetails";
import CoursePlayer from "./pages/CoursePlayer";
import CertificatePreview from "./pages/CertificatePreview";
import ReviewPopup from "./Components/ReviewPopup";


/* ================= COMPONENTS ================= */
import PrivateRoute from "./Components/PrivateRoute";

/* ================= LAYOUT ================= */
import CoursesLayout from "./Layout/CoursesLayout";

/* ================= TOAST ================= */
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
      />

      {/* Provider wraps routes */}
      <CartWishlistProvider>
        <Routes>
          {/* HOME */}
          <Route path="/" element={<Home />} />

          {/* Layout pages */}
          <Route element={<CoursesLayout />}>

            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetails />} />
            <Route
              path="/courseDetails/:courseId"
              element={<CourseDetails />}
            />

            <Route path="/certificate/:courseId" element={<CertificatePreview />}/>
            



            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />

            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/:id" element={<Checkout />} />

            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/otp" element={<OTP />} />

            <Route path="/profile" element={<Profile />} />

            <Route
              path="/mycourse"
              element={
                <PrivateRoute>
                  <MyCourse />
                </PrivateRoute>
              }
            />

            <Route path="/teacher" element={<Teacher />} />
            <Route path="/teacherCourse" element={<TeacherCourse />} />
            <Route path="/addCourse" element={<AddCourse />} />

            <Route
              path="/teacherCourse/editcourse/:id"
              element={<EditCourse />}
            />

            <Route
              path="/teacherCourse/uploadvideo/:id"
              element={<UploadVideo />}
            />

            <Route
              path="/teacherCourse/editVideo/:courseId"
              element={<EditVideo />}
            />

            <Route
              path="/teacherCourse/details/:courseId"
              element={<TeacherCourseDetails />}
            />

            <Route
              path="/uploadCertificate/details/:courseId"
              element={<UploadCertificate />}
            />
            
            <Route
              path="/reviewPopup/details/:courseId"
              element={<ReviewPopup />}
            />


            <Route
              path="/myCourseDetails/:courseId"
              element={<MyCourseDetails />}
            />
          </Route>
        

          {/* Course Player */}
          <Route
            path="/coursePlayer/:id"
            element={
              <PrivateRoute>
                <CoursePlayer />
              </PrivateRoute>
            }
          />
        </Routes>
      </CartWishlistProvider>
    </BrowserRouter>
  );
}

